define(function (require, exports) {
    'use strict';

    var sdkinit = require('XmSdk');
   // var sdkui = require('metro-module-sdkui');
    var sdk = new sdkinit.XmSdk();


    /**
     * @ngInject
     */
    function metroTransmit(metroUiHandler,tulipProvider) {

        return {
            authenticate: function(csPrefsNumber,obj,containerElement){
                return new Promise( function(resolve,reject){
                    sdk.authenticate(csPrefsNumber, 'user_login_journey_phase2', obj, containerElement)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (err) {
                        reject(err);
                    });
                })
            },
            invokePolicy: function(journey,obj,containerElement){
                return new Promise( function(resolve,reject){
                    sdk.invokePolicy( journey, obj, containerElement)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (err) {
                        reject(err);
                    });
                })
            },
            invokeAnonymousPolicy: function(journey,obj,containerElement){
                return new Promise( function(resolve,reject){
                    sdk.invokeAnonymousPolicy( journey, obj, containerElement)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (err) {
                        reject(err);
                    });
                })
            },
            setConnectionSettings: function(connection){
                sdk.setConnectionSettings(connection);
                return this;
            },
            initialize: function(){
                sdk.initialize().then(
                    function(){
                        console.info("initialized successfully");
                    }).catch(
                    function(err){
                        console.info("Error: " + err.getMessage());
                    });
            },
            setUiHandler: function(handler){
                sdk.setUiHandler(handler);
                sdk.setLogLevel(5);
            },
            logout: function(){
                sdk.logout()
                    .then(function () {})
                    .catch(function () {})
            },
            logoutPromise: function(){
                return new Promise( function(resolve,reject){
                    sdk.logout()
                    .then(function () {resolve(true)})
                    .catch(function (err) {reject(err)})
                })
            },
            reinitialize: function(){
                return sdk.logout()
                    .then((function () {this.initialize()}).bind(this))
                    .catch((function () {this.initialize()}).bind(this))
            },
            formatMdoduleString:function(request){
                 if(request.sub_flow_type1 == "password-update"){
                     return "Change Password"
                 }
                 else if(request.sub_flow_type1=="user" &&  (request.customer_operation == "amend" || request.customer_operation == "change")){
                    return "Amend Users"
                 }
                 else if(request.sub_flow_type1=="user" &&  request.customer_operation == "create"){
                    return "Create Users"
                 }

                 else if(request.sub_flow_type1=="mandates" &&  request.customer_operation == "create"){
                    return "Create Mandate"
                 }

                 else if(request.sub_flow_type1=="mandates" &&  (request.customer_operation == "amend" || request.customer_operation == "change")){
                    return "Amend Mandate"
                 }

                 else if(request.sub_flow_type1=="access_groups" &&  request.customer_operation == "create"){
                    return "Create Access Group"
                 }

                 else if(request.sub_flow_type1=="access_groups" &&  (request.customer_operation == "amend" || request.customer_operation == "change")){
                    return "Amend Access Group"
                 }

                 else if(request.sub_flow_type1=="account_groups" &&  request.customer_operation == "create"){
                    return "Create Account Group"
                 }

                 else if(request.sub_flow_type1=="account_groups" &&  (request.customer_operation == "amend" ||  request.customer_operation == "change")){
                    return "Amend Account Group"
                 }

                 else if(request.sub_flow_type1=="beneficiary" &&  request.customer_operation == "create"){
                    return "Setup New Trusted Beneficiary"
                 }

                 else if(request.sub_flow_type1=="beneficiary" &&  (request.customer_operation == "edit" || request.customer_operation == "amend" || request.customer_operation == "change")){
                    return "Amend Trusted Beneficiary"
                 }

                 else if (request.isPA == true && request.customer_operation=="approve"){
                    return "Authenticating online payments"
                 }

                 else if (request.isPA == false && request.customer_operation=="approve"){
                    return "Authenticating your card"
                 }


            },
            widgetTransmitSetup: function(){
                let scaEnable = false;
                this.setUiHandler(metroUiHandler.CustomUIHandler);
                return tulipProvider.getConfigData().then((function(response){
                    if(response.data && response.data.isScaPaymentEnabled){
                        var configData = response.data;
                        scaEnable = true;
                        const endpoint = configData.scaUrl;
                        const appID = configData.appId;
                        let doubleEncryption = configData.doubleEncryptionEnabled;
                        let connectionSettings;
                        if (doubleEncryption=="N")
                        {
                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.create(endpoint, appID);
                        } else {
                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(endpoint, appID,null, null, com.ts.mobile.sdk.ConnectionCryptoMode.Credentials);
                        }                        
                        this.setConnectionSettings(connectionSettings).initialize();
                    }else{
                        scaEnable = false;
                    }
                    return scaEnable
                    }).bind(this), function(error) {
                        return false;
                    });
            },
            widgetTransmitSetupBulk: function(){
                let scaEnable = false;
                this.setUiHandler(metroUiHandler.CustomUIHandler);
                return tulipProvider.getConfigData().then((function(response){
                    if(response.data && response.data.isScaPaymentEnabled){
                        var configData = response.data;
                        scaEnable = true;
                        const endpoint = configData.scaUrl;
                        const appID = configData.appId;
                        let doubleEncryption = configData.doubleEncryptionEnabled;
                        let connectionSettings;
                        if (doubleEncryption=="N")
                        {
                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.create(endpoint, appID);
                        } else {
                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(endpoint, appID,null, null, com.ts.mobile.sdk.ConnectionCryptoMode.Credentials);
                        }
                        this.setConnectionSettings(connectionSettings).initialize();
                    }else{
                        scaEnable = false;
                    }
                    return {
                        scaEnable:scaEnable,
                        fetchBenWaitTime:configData.fetchBenWaitTime,
                        benAccRepetitionLeft:configData.benAccRepetitionLeft
                    }
                    }).bind(this), function(error) {
                        return false;
                    });
            },
            handleError: function(error){
                let messages = [];
                if(error === 'incorrect'){
                    messages = [{category:"payments",itemRef:null,responseCode:"LOGIN_INCORRECT",level:"error",detail:"Something's not quite right. Please check that your details are correct and try again. If you get your details wrong too many times, we will lock your account to keep it safe.",message:"Error: ",icon:"close",show:true,showDetail:true}]
                }
                if(error === 'generic'){
                    messages = [{category:"payments",itemRef:null,responseCode:"LOGIN_GENERIC",level:"error",detail:"Something went wrong, please try again later",message:"Error: ",icon:"close",show:true,showDetail:true}]
                }
                if(error === 'oneattemptleft'){
                    messages = [{category:"payments",itemRef:null,responseCode:"LOGIN_ONE_ATTEMPT_LEFT",level:"error",detail:"Some of the details you entered aren’t quite right. Please try again.You have 1 attempt left before we lock your account to keep it safe.",message:"Error: ",icon:"close",show:true,showDetail:true}]
                }
                if(error === 'oldpwd'){
                    messages = [{category:"payments",itemRef:null,responseCode:"OLD_PASSWORD_CRITERIA",level:"error",detail:"Password is the same as one of a previous",message:"Error: ",icon:"close",show:true,showDetail:true}]
                }
                if(error ==='passwordconstrainerror'){
                    messages = [{category:"passwordconstrainerror",itemRef:null,responseCode:"PASSWORD_CONSTRAIN",level:"error",detail:"Sorry – that password doesn’t meet our password criteria, please pick a different one.", message:"Error: ",icon:"close",show:true,showDetail:true}]
                }
                if(error === 'blockedprocess'){
                    messages = [{category:"payments",itemRef:null,responseCode:"SCACHK_PROCESS",level:"error",detail:"Unfortunately we cannot process your request right now. Please try again later or call us on 0345 08 08 500",message:"Error: ",icon:"close",show:true,showDetail:true}]
                }
                if(error === 'login_failure_locked_out'){
                    messages = { "errors":[{"title":"LOGIN_FAILURE_LOCKED_OUT","show":true,"showDetail":false,"level":"error","icon":"close","id":"LOGIN_FAILURE_LOCKED_OUT","category":"security"}]}
                }
                if(error === 'login_transmit_failure'){
                    messages = {"errors": [{"title": "LOGIN_TRANSMIT_FAILURE","show": true,"showDetail": false,"messages":"<p>Unfortunately there is a problem, please try again. If it continues, please call us on 0345 08 08 500 and we’ll help you.</p>","level": "error","icon": "close","id": "LOGIN_TRANSMIT_FAILURE","category": "security"}]}
                }
                if(error==='approvalunselected'){
                    messages = [{category:"approvalunselected",itemRef:null,responseCode:"APPROVAL_UNSELECTED",level:"error",detail:"Please select an option for each request shown.", message:"",icon:"close",show:true,showDetail:true,inlineMesssage:'You must select approve or decline to continue'}]
                }
                if(error==='cardsgeneric_PA'){
                    messages = [{category:"cards",itemRef:null,responseCode:"CARD_GENERIC",level:"error",detail:"Sorry, something's gone wrong please try again. If this keep happening, please call us on 0345 08 08 500",message:"",icon:"close",show:true,showDetail:true,inlineMesssage:"This payment decision couldn't be sent, please try again"}]
                }
                if(error==='cardsgeneric_NPA'){
                    messages = [{category:"cards",itemRef:null,responseCode:"CARD_GENERIC",level:"error",detail:"Sorry, something's gone wrong please try again. If this keep happening, please call us on 0345 08 08 500",message:"",icon:"close",show:true,showDetail:true,inlineMesssage:"This card authorisation couldn't be sent, please try again."}]
                }
                if(error==='tysys_failure_PA'){
                    messages = [{category:"cards",itemRef:null,responseCode:"tysys_failure",level:"error",detail:"",message:"Sorry, something's gone wrong please try again.<br> If this keeps happening, please call us on 0345 08 08 500",icon:"close",show:true,showDetail:true,inlineMesssage:"Something's gone wrong with this payment, please return to the seller and try again."}]
                }
                if(error==='tysys_failure_NPA'){
                    messages = [{category:"cards",itemRef:null,responseCode:"tysys_failure",level:"error",detail:"",message:"Sorry, something's gone wrong please try again.<br> If this keeps happening, please call us on 0345 08 08 500",icon:"close",show:true,showDetail:true,inlineMesssage:"Something's gone wrong with this request, please return to the seller and try again."}]
                }
                if(error==='cardsgenericmultiple'){
                    messages = [{category:"cardsgenericmultiple",itemRef:null,responseCode:"CARDS_AUTHORISE",level:"error",detail:"Sorry, something's gone wrong please try again. If the problem persists please call us on 0345 08 08 500",message:"",icon:"close",show:true,showDetail:true,inlineMesssage:"This card authorisation couldn't be sent, please try again"}]
                }
                if(error === 'transmit_high_risk'){
                    messages = [{category:"TRANSMIT_HIGH_RISK",itemRef:null,responseCode:"TRANSMIT_HIGH_RISK",level:"error",detail:"Sorry, something has gone wrong.",message:"",icon:"close",show:true,showDetail:true,inlineMesssage:""}];
                }
                return messages;
            },

            initiateTransmitCards: function(){
                let scaCardsEnabled = false;
                this.setUiHandler(metroUiHandler.CustomUIHandler);
                return tulipProvider.getConfigData().then((function(response){
                    if(response.data && response.data.isScaCardsEnabled){
                        var configData = response.data;
                        scaCardsEnabled = true;
                        const endpoint = configData.scaUrl;
                        const appID = configData.appId;
                        let doubleEncryption = configData.doubleEncryptionEnabled;
                        let connectionSettings;
                        if (doubleEncryption=="N")
                        {
                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.create(endpoint, appID);
                        } else {
                            connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(endpoint, appID,null, null, com.ts.mobile.sdk.ConnectionCryptoMode.Credentials);
                        }
                        this.setConnectionSettings(connectionSettings).initialize();
                    }else{
                        scaCardsEnabled = false;
                    }
                    return scaCardsEnabled
                    }).bind(this), function(error) {
                        return false;
                    });
            }
        };
    }

    /**
     * Exports
     */
    exports.metroTransmit = metroTransmit;
});



// WEBPACK FOOTER //
// ./scripts/services/metroTransmitService.js